<template>
  <div>
    <div class="card overflow-auto">
      <slot name="header"></slot>
      <div v-show="loaded">
        <slot v-if="value.length > 0"></slot>
        <no-result v-else :text="empty_message"></no-result>
      </div>
      <div class="justify-content-md-center" v-show="!loaded">
        <loading-spinner></loading-spinner>
      </div>
    </div>
    <div class="text-center" v-show="loaded && value.length > 0 && next">
      <button
        class="btn mt-3 btn-outline-secondary"
        @click="
          page++;
          spin($event, load, false);
        "
      >
        {{ 'load_more' | t }}
      </button>
    </div>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';
import debounce from 'debounce-promise';

export default {
  props: ['value', 'model', 'empty_result', 'params', 'autoload'],
  data: function () {
    return {
      loaded: false,
      next: true,
      page: 1,
      latest_params: {}
    };
  },
  computed: {
    empty_message() {
      return this.empty_result || this.$t('no_' + this.model);
    }
  },
  methods: {
    fire: async function (paged_params, reload) {
      let { data, links, meta } = await Api.findAll(this.model, paged_params);
      this.next = !!links.next;

      if (reload) {
        this.$emit('input', data);
      } else {
        this.$emit('input', this.value.concat(data));
      }

      this.$emit('meta', meta);
    },
    load: handle(async function (reload, force) {
      var paged_params = {
        ...(this.params || {}),
        page: { number: this.page }
      };

      if (
        this.latest_params !== void 0 &&
        this.params !== void 0 &&
        _.isEqual(this.latest_params, paged_params) &&
        !force
      ) {
        console.log('Same query, ignoring', paged_params, this.latest_params);
        this.loaded = true;
        return;
      }

      if (reload) {
        this.loaded = false;
      }

      if (reload) {
        this.page = 1;
        paged_params.page.number = 1;
      }

      this.latest_params = _.cloneDeep(paged_params);

      await this.fire(paged_params, reload);

      this.loaded = true;
    }),
    load_debounce: async function (reload, force) {
      this.loaded = false;
      this._load_debounce(reload, force);
    },
    _load_debounce: debounce(async function (reload, force) {
      this.load(reload, force);
    }, 500)
  },
  async mounted() {
    if (this.autoload === void 0 || this.autoload === true) {
      this.load();
    }
  }
};
</script>

<style scoped></style>
